import { Box } from '@hover/blueprint';
import React from 'react';

import { CurrentDesignMenu } from 'src/modules/designStudio/components/DesignMenu/ProductCatalogMenu/CurrentDesignMenu';
import { UIKind } from 'src/modules/designStudio/components/DesignStudio/UILayer/types';
import { SlideSmartMenu } from 'src/modules/designStudio/components/Toolbar/SlideSmartMenu';
import type { Menu } from 'src/modules/designStudio/constants';
import { UILayerProvider } from 'src/modules/designStudio/providers';
import { useIsLandscape } from 'src/shared/hooks';

interface CurrentDesignCardProps {
  onHeightChange: (currentHeight: number) => void;
  menu: Menu | null;
  toolbarRef: React.RefObject<HTMLElement> | null;
}

const CurrentDesignCard = ({
  onHeightChange,
  menu,
  toolbarRef,
}: CurrentDesignCardProps) => {
  const [isLandscape] = useIsLandscape();
  return (
    <UILayerProvider kind={isLandscape ? UIKind.LANDSCAPE : UIKind.MOBILE}>
      <SlideSmartMenu
        closeMenu={() => null}
        closeable={false}
        containerRef={toolbarRef}
        menu={menu}
        onHeightChange={onHeightChange}
        testId="current-design-card"
      >
        <Box display="block">
          <CurrentDesignMenu />
        </Box>
      </SlideSmartMenu>
    </UILayerProvider>
  );
};

export { CurrentDesignCard };
